export default {
  "content": "<path fill=\"#028EB7\" d=\"M6.612.007a6.6 6.6 0 015.304 10.54l3.568 3.018a1.364 1.364 0 11-1.923 1.922l-3.018-3.567A6.606 6.606 0 116.613.007zm0 11.826a5.217 5.217 0 100-10.434 5.217 5.217 0 000 10.434z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};